<div class="preloader" [hidden]='!display'>
  <div class="status">
      <div class="spinner-border avatar-sm text-primary m-2" role="status"></div>
  </div>
</div>